import type { SelectHTMLAttributes, ReactNode } from 'react';
import styles from './Select.module.css';

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  placeholder?: string;
  children: ReactNode;
}

export function Select({ placeholder, className, children, ...rest }: SelectProps) {
  const cls = className ? `${styles.select} ${className}` : styles.select;
  return (
    <select className={cls} {...rest}>
      {placeholder !== undefined && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {children}
    </select>
  );
}
